import { render } from "./CompanyBillingHistory.vue?vue&type=template&id=4b488bbd"
import script from "./CompanyBillingHistory.vue?vue&type=script&lang=js"
export * from "./CompanyBillingHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__